// extracted by mini-css-extract-plugin
export default {"toolbarSection":"ToolbarSection_toolbarSection__2sPUx"};